import { useQuery } from '@tanstack/react-query';
import fetchLotsForOverview from 'features/lots/api/fetchLotsForOverview';

/**
 * The By-item overview's lots — see fetchLotsForOverview for the query
 * semantics (unpaginated, newest-first, Empty behind a toggle).
 *
 * No mutation-driven invalidation: the default staleTime (0) refetches
 * on every tab mount and window focus, and lot mutations happen on
 * other surfaces. The quarantine modal invalidates 'getLotsByItem'
 * itself, since a recall changes this view directly.
 */
export default function useLotsByItem({
  projectDocId = null,
  kind = 'all',
  includeEmpty = false,
}) {
  return useQuery({
    queryKey: ['getLotsByItem', projectDocId, kind, includeEmpty],
    queryFn: () => fetchLotsForOverview({ projectDocId, kind, includeEmpty }),
  });
}
